import styled from "styled-components";

export const StyleResult = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #000000a3;
  margin: 0 auto;
  row-gap: 0px;
  /* border-bottom: 1px solid #ffffff;
  border-top: 1px solid #ffffff; */
  ${({ theme }) =>
      theme.media.monitor(
      `
        margin-top: 20px;
      `,
    )}
      ${({ theme }) =>
      theme.media.mobile(
      `
        height: 210px;
        justify-content: space-between;
      `,
    )}
`;

export const DamageGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding: 1vw;  
  ${({ theme }) =>
    theme.media.mobile(
      `
        flex-direction: column;
        row-gap: 5px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
        padding: 13px;
        row-gap: 0px;
      `,
    )}
`;

export const DamageTitle = styled.div`
  font-size: 22px;
  font-weight: 500;
  font-family: 'Inter medium', 'Suit medium';
  display: flex;
  color: #ffffff;
  p {
    color: #F12304;
    font-weight: 600;
  }
  ${({ theme }) =>
      theme.media.monitor(
      `
        font-size: 30px;
      `,
    )}
  ${({ theme }) =>
    theme.media.tablet(
      `
      font-size: 19px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
      font-size: 12px;
      `,
    )}
`;

export const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  font-family: 'Suit medium', 'Inter medium';
  ${({ theme }) =>
      theme.media.monitor(
      `
        font-size: 36px;
      `,
    )}
  ${({ theme }) =>
    theme.media.tablet(
      `
        font-size: 20px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      ` 
        font-size: 14px;
      `,
    )}
`;

export const StyledResultCar = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 32.5% 32.5% 32.5%;
  grid-column-gap: 1.25%;
  margin: 0 auto;
  padding: 1.5vw;
  box-sizing: border-box;
  margin-top: 0.5vw;
`;

export const CarGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 44% 55%;
  grid-column-gap: 1%;
`;

export const CarList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const CarDamageList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  row-gap: 1vw;
`;

export const CarDamage = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 18% 80%;
  place-items: flex-start;
  grid-column-gap: 2%;
`

export const CarNum = styled.div`
  width: 1.3vw;
  height: 1.3vw;
  padding: 1vw;
  box-sizing: border-box;
  background: #ffffff;
  color: #000000;
  font-size: 1.3vw;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Inter bold';
`;

export const CarDamageGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 0.5vw;
`;

export const CarType = styled.span`
  font-size: 1.1vw;
  font-family: 'Inter bold';
  color: #ffffffcf;
  ${({ theme }) =>
      theme.media.monitor(
      `
        font-size: 27px;
      `,
    )}
`;

export const CarTypeText = styled.span`
  font-size: 1.2vw;
  font-family: 'Inter bold';
  color: #fc5f5fcf;
  width:100%;
  ${({ theme }) =>
      theme.media.monitor(
      `
        font-size: 27px;
      `,
    )}
`

export const Car = styled.img`
  width: 100%;
  height: 100%;
`;

export const DamageCar = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
`;

export const GridCar = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`

export const StyleResultText = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
  ${({ theme }) =>
      theme.media.monitor(
      `
        column-gap: 20px;
      `,
    )}
  ${({ theme }) =>
    theme.media.tablet(
      `
        column-gap: 10px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
        width: 100%;
        column-gap: 5px;
      `,
    )}
`;

export const InspectionColor = styled.div`
  width: 13px;
  height: 13px;
  ${({ theme }) =>
    theme.media.tablet(
      `
        width: 10px;
        height: 10px;
      `,
    )}
      ${({ theme }) =>
    theme.media.mobile(
      `
        width: 8px;
        height: 8px;
      `,
    )}
`;

export const InspectionText = styled.div`
  font-size: 18px;
  font-weight: 500;
  font-family: 'Suit medium', 'Inter medium', sans-serif;
  color: #ffffff;
  ${({ theme }) =>
      theme.media.monitor(
      `
        font-size: 24px;
      `,
    )}
  ${({ theme }) =>
    theme.media.tablet(
      `
        font-size: 14px;  
      `,
    )}
    ${({ theme }) =>
    theme.media.mobile(
      `
        font-size: 8px;  
      `,
    )}
`;

export const StyledButton = styled.button`
  background-color: transparent;
  color: white;
  border: white 1px solid;
  border-radius: 5px;
  padding: 10px 25px;
  font-family: 'Suit medium';
  ${({ theme }) =>
    theme.media.monitor(
      `
        font-size: 20px;
      `,
    )}
`;